import React, { useState } from 'react';
import { 
    Box, 
    Tabs, 
    Tab,
    Typography,
    Paper
} from '@mui/material';
import SkillGraphSummaryReport from './SkillGraphSummary/SkillGraphSummaryReport';
import JobRoleReadinessReport from './JobRoleReadiness/JobRoleReadinessReport';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`report-tabpanel-${index}`}
            aria-labelledby={`report-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>{children}</Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `report-tab-${index}`,
        'aria-controls': `report-tabpanel-${index}`,
    };
}

const SkillsAndRolesReport = () => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <div sx={{ width: '100%' }}>            
            <Tabs 
                value={activeTab} 
                onChange={handleTabChange} 
                aria-label="report tabs"
                sx={{ 
                    //px: 2,
                    '& .MuiTab-root': {
                        //minHeight: '64px'
                    }
                }}
            >
                <Tab 
                    label={                            
                        <Typography variant="body2" color="textSecondary">
                            Skills
                        </Typography>                           
                    } 
                    {...a11yProps(0)} 
                />
                <Tab 
                    label={                            
                        <Typography variant="body2" color="textSecondary">
                            Job Readiness
                        </Typography>
                    } 
                    {...a11yProps(1)} 
                />
            </Tabs>
            

            <TabPanel value={activeTab} index={0}>
                <SkillGraphSummaryReport />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
                <JobRoleReadinessReport />
            </TabPanel>
        </div>
    );
};

export default SkillsAndRolesReport;